<script lang="ts" setup>
import { t } from '@/Support/lang'
import { OhVueIcon } from 'oh-vue-icons'
import { computed } from 'vue'

interface Props {
  membership?: boolean | null
  vip?: boolean | null
  ai?: boolean | null
  tooltip?: string | null
}

const props = withDefaults(defineProps<Props>(), {
  tooltip: null,
})

const tooltipText = computed(
  () =>
    props.tooltip ||
    t(props.ai ? 'Individual Membership with AI' : 'Individual Membership'),
)

const show = computed(() => props.membership || props.vip || props.ai)
</script>
<template>
  <OhVueIcon
    :name="ai ? 'hi-solid-badge-check' : 'hi-badge-check'"
    v-if="show"
    v-tooltip="tooltipText"
    class="text-accent-500 outline-hidden"
    :class="[vip ? 'text-indigo-500' : 'text-accent-500']"
  />
</template>
